import type { RouteObject } from 'react-router';
import { EventsPage } from './pages/events-page';

export const eventsRoutes: RouteObject[] = [
  { path: 'events', element: <EventsPage /> },
];
